/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-05-19 18:49:43
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\success\locales\zh-TW.ts
 */
export default {
  'page.success.txtsucess': '註冊成功，請登錄後及時認證並完善個人信息。',
  'page.activation.txterror': '註冊失敗',
  'page.success.login': '登錄',
};
